import { render, staticRenderFns } from "./SquishyThumb.vue?vue&type=template&id=54958f85&scoped=true&lang=pug&"
import script from "./SquishyThumb.vue?vue&type=script&lang=js&"
export * from "./SquishyThumb.vue?vue&type=script&lang=js&"
import style0 from "./SquishyThumb.vue?vue&type=style&index=0&id=54958f85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54958f85",
  null
  
)

export default component.exports